// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { CatalogueProductFragmentDoc } from '../../../graphql/api/product/catalogueProduct.fragment.generated';
import { ReadyToGoRingLinkFragmentDoc } from '../../../router/fragments/readyToGoRingLink.fragment.generated';
import { ProductGalleryFragmentDoc } from '../../../components/layout/gallery/ProductGallery.generated';
import { ProductPageMetaFragmentDoc } from '../composables/useProductPageMeta.generated';
import { TaxSnippetFragmentDoc } from '../../../components/rings/TaxSnippet.generated';
import { RecommendedRingSizeFragmentDoc } from '../../../graphql/api/product/rings/fragments/recommendedRingSize.fragment.generated';
import { ReadyToGoRingVariationsFragmentDoc } from '../../../graphql/api/product/rings/ready-to-go/fragments/readyToGoRingVariations.fragment.generated';
import { CatalogueReadyToGoRingTranslationFragmentDoc } from '../../../graphql/api/product/rings/ready-to-go/fragments/catalogueReadyToGoRingTranslation.fragment.generated';
import { ReviewsFragmentDoc } from '../../../components/rings/Reviews.generated';
export const ReadyToGoRingFragmentDoc = gql`
    fragment readyToGoRing on CatalogueReadyToGoRing {
  ...catalogueProduct
  carat
  gemType
  sku
  ...productGallery
  ...readyToGoRingLink
  ...productPageMeta
  salePrice(region: $region, currency: $currency) {
    ...taxSnippet
  }
  sizes {
    ...recommendedRingSize
  }
  variations {
    ...readyToGoRingVariations
  }
  translation(locale: $locale) {
    ...catalogueReadyToGoRingTranslation
  }
  isReadyToShip
  reviews {
    ...reviews
  }
}
    ${CatalogueProductFragmentDoc}
${ProductGalleryFragmentDoc}
${ReadyToGoRingLinkFragmentDoc}
${ProductPageMetaFragmentDoc}
${TaxSnippetFragmentDoc}
${RecommendedRingSizeFragmentDoc}
${ReadyToGoRingVariationsFragmentDoc}
${CatalogueReadyToGoRingTranslationFragmentDoc}
${ReviewsFragmentDoc}`;